module.exports = __webpack_public_path__ + "img/Portugal.f48dbfe8.png";